import { validateResponseHasSchema } from '@/shared/api/validation'
import { createAssetManagementClient } from '@/shared/api/client'
import { z } from 'zod'
import { AssetType } from '@/features/assets/constants'

const client = createAssetManagementClient()

export const checkAssetCreationEligibility = (unifiiProjectCode: number, assetType: AssetType, wheelingProjectCode?: string) => validateResponseHasSchema(
  client.sendGet(`v2/assets/create/eligibility`, { unifiiProjectCode, type: assetType, wheelingProjectCode }),
  z.object({
    data: z.object({
      unifiiProjectCode: z.number(),
      wheelingProjectCode: z.string().nullable(),
      projectName: z.string(),
      projectAddress: z.string(),
      type: z.nativeEnum(AssetType),
      wheelingAllocationSize: z.number().nullable(),
    })
  })
).then(
  res => res.data
);
